import * as React from "react"
import _ from 'lodash' 
import styled, { keyframes }  from "styled-components";

const UpAndDown = keyframes`
  from { transform: scaleY(1); }
  to { transform: scaleY(0.5); }
`

const StyledSVG = styled.svg`
`

const OuterSquare = styled.rect`
  fill: ${(props) => props.theme.highlightColor};
` 
const Bar= styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
  stroke: none;
  transform-origin: center;
`

const BarOne = styled(Bar)`
  animation: ${UpAndDown} 2.5s linear alternate infinite;
  animation-delay: 250ms;
`

const BarTwo = styled(Bar)`
  animation: ${UpAndDown} 6s linear alternate infinite;
  animation-delay: 250ms;
`

const BarThree = styled(Bar)`
  animation: ${UpAndDown} 2s linear alternate infinite;
  animation-delay: 250ms;
`
const BarFour = styled(Bar)`
  animation: ${UpAndDown} 4s linear alternate infinite;
  animation-delay: 250ms;
`
const BarFive = styled(Bar)`
  animation: ${UpAndDown} 3s linear alternate infinite;
  animation-delay: 250ms;
`

const BarGraph = (props) => {
  return (
    <StyledSVG viewBox="0 0 100 100" {...props}>
      <OuterSquare x="44" y="51" width="40" height="38" />
      <BarOne x="43" y="50" width="10" height="40" />
      <BarTwo x="51" y="50" width="10" height="40" />
      <BarThree x="59" y="50" width="10" height="40" />
      <BarFour x="67" y="50" width="10" height="40" />
      <BarFive x="75" y="50" width="10" height="40" />
    </StyledSVG>
  )
}

export default BarGraph
